/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { Col, Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import TopAnalyticsCard from '../../components/detailsAnalytics/topCard';
import React, { useEffect, useState } from 'react';
import { getSinglePost } from '../../redux/slices/analytics/postsList';
import { DonutChart } from '../../components/charts/donutChart';
import {
  DETAILS_ANALYTICS_METRICS_ORDER,
  PLATFORMS_COLORS,
  SHORT_ANALYTICS_METRICS_TITLES
} from '../../config/constants';
const DetailsAnalytics: React.FC = () => {
  const { postuuid } = useParams();
  const [post, setPost] = useState({} as any);
  const [error, setError] = useState({} as any);
  const [data, setData] = useState({} as any);
  const formatData = (data: any): any => {
    const formattedData: any = {};
    SHORT_ANALYTICS_METRICS_TITLES.map((metric: string) => {
      Object.keys(data).map((platform: any) => {
        if (!formattedData[metric]) formattedData[metric] = [];
        if (!data[platform][metric]) return;
        formattedData[metric].push({ platform, value: data[platform][metric] });
      });
    });
    return formattedData;
  };

  useEffect(() => {
    if (!postuuid) return;
    getSinglePost(postuuid)
      .then((res) => {
        setPost(res);
        setData(formatData(res?.analytics?.data_as_json?.overview));
      })
      .catch((err) => {
        console.log(err);
        setError(err);
      });
  }, [postuuid]);
  console.log(post);
  return (
    <Container>
      <div className="m-2" />
      <TopAnalyticsCard
        data={{
          impressions: post?.analytics?.sum_impressions,
          reactions: post?.analytics?.sum_reactions,
          shares: post?.analytics?.sum_shares,
          comments: post?.analytics?.sum_comments,
          reach: post?.analytics?.sum_reach
        }}
      />
      <div className="m-2" />
      <div className="row gx-5">
        {post?.analytics?.data_as_json?.overview &&
          Object.keys(data)
            .sort((a, b) => {
              const indexA = DETAILS_ANALYTICS_METRICS_ORDER.indexOf(a);
              const indexB = DETAILS_ANALYTICS_METRICS_ORDER.indexOf(b);
              return indexA - indexB;
            })
            .map((key: any) => {
              console.log(data, 'data');
              if (data[key].length < 1) return null;
              return (
                <React.Fragment key={key}>
                  <Col sm={6} className="gy-5 d-flex justify-content-center">
                    <DonutChart
                      title={key}
                      colors={data[key].map(
                        (item) => PLATFORMS_COLORS[item.platform]
                      )}
                      series={data[key].map((item) => item.value)}
                      labels={data[key].map((item) => item.platform)}
                      details={data[key]}
                    />
                  </Col>
                </React.Fragment>
              );
            })}
      </div>
    </Container>
  );
};
export default DetailsAnalytics;
